"use strict";

// Depends
window.$ = window.jQuery = require("jquery");
window.validate = require("jquery-validation");
require("bootstrap-sass");

// Modules
var Forms = require("./components/forms");
var Slider = require("./components/slider");
var Fancy_select = require("./components/fancyselect");
var Popup = require("./components/popup");

// Accordion
if ($(".toggle .toggle-title").hasClass("active")) {
    $(".toggle .toggle-title.active")
        .closest(".toggle")
        .find(".toggle-inner")
        .show();
}
$(".toggle .toggle-title").click(function() {
    if ($(this).hasClass("active")) {
        $(this)
            .removeClass("active")
            .closest(".toggle")
            .find(".toggle-inner")
            .slideUp(200);
    } else {
        $(this)
            .addClass("active")
            .closest(".toggle")
            .find(".toggle-inner")
            .slideDown(200);
    }
});

//Default Slick Slider
$(".default-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    cssEase: "linear",
    autoplay: true,
    autoplaySpeed: 2000,
});

// Are you ready?
$(function() {
    new Forms();
    new Fancy_select();
    new Slider();
    new Popup();

    // Прокрутка к якорю
    $(".menu").on("click", ".go_to", function(e) {
        e.preventDefault();
        var id = $(this).attr("href"),
            top = $(id).offset().top;
        $("body, html").animate(
            {
                scrollTop: top,
            },
            1500
        );
    });

    // FAQ

    $(".faq-list").on("click", "li", function() {
        if ($(this).hasClass("active")) {
            $(this)
                .removeClass("active")
                .siblings()
                .removeClass("active");
            $(this)
                .find(".faq-header")
                .addClass("active")
                .find("i")
                .html("+");
        } else {
            $(this)
                .addClass("active")
                .siblings()
                .removeClass("active");
            $(this)
                .find(".faq-header")
                .removeClass("active")
                .find("i")
                .html("–");
            $(this)
                .siblings()
                .find("i")
                .html("+");
        }
        $(this)
            .find(".faq-body")
            .slideToggle();
        $(this)
            .siblings()
            .find(".faq-body")
            .slideUp();
    });

    // test tab

    $(".tabs-list").on("click", ".tabs-item", function() {
        if ($(this).hasClass("active")) {
            $(this)
                .removeClass("active")
                .siblings()
                .removeClass("active");
            $(this)
                .find(".tabs-title")
                .addClass("active");
        } else {
            $(this)
                .addClass("active")
                .siblings()
                .removeClass("active");
            $(this)
                .find(".tabs-title")
                .removeClass("active");
        }
        $(this)
            .find(".tabs-content")
            .slideToggle();
        //$(this).siblings().find('.tabs-content').slideUp();
    });

    //tabs
    (function($) {
        $(function() {
            $(".tabs").on("click", "li:not(.active)", function() {
                $(this)
                    .addClass("active")
                    .siblings()
                    .removeClass("active")
                    .closest(".tabs-wrapper")
                    .find(".tabs-content")
                    .removeClass("active")
                    .eq($(this).index())
                    .addClass("active");
            });
        });
    })(jQuery);

    // fixed menu

    $(window).scroll(function() {
        if ($(this).scrollTop() > 50) {
            $(".header").addClass("active");
        } else {
            $(".header").removeClass("active");
        }
    });

    // mobile menu

    var touch = $(".header-menu__btn");
    var menu = $(".header-menu ul");

    var toggles = document.querySelectorAll(".main-menu__btn");

    for (var i = toggles.length - 1; i >= 0; i--) {
        var toggle = toggles[i];
        toggleHandler(toggle);
    }

    function toggleHandler(toggle) {
        toggle.addEventListener("click", function(e) {
            e.preventDefault();
            this.classList.contains("active") === true
                ? this.classList.remove("active")
                : this.classList.add("active");
        });
    }

    $(touch).on("click", function(e) {
        e.preventDefault();
        menu.slideToggle();
        $(".main").toggleClass("active");
    });
});

// Loader spin
$(window).on("load", function() {
    $(".preloader").fadeOut(200);
});

// Main slider
jQuery(document).ready(function() {
    function createSlick() {
        jQuery(".main-slider")
            .not(".slick-initialized")
            .slick({
                autoplay: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                autoplaySpeed: 4000,
            });
    }
    createSlick();

    // testimonial slider - home
    $(".accordion-container").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true,
        cssEase: "linear",
        pauseOnHover: true,
        swipe: true,
        autoplay: true,
        autoplaySpeed: 8000,
        adaptiveHeight: true,
    });

    //Now it will not throw error
    $(window).on("resize", createSlick);
});

// -- Vertical Tabs on Homepage

$(document).ready(function() {
    //-- Select the first tab and div by default

    $(".home__tabs > ul > li > a")
        .eq(0)
        .addClass("selected");
    $(".home__tabs > div > article")
        .eq(0)
        .css("display", "block");

    //-- This assigns an onclick event to each tab link("a" tag) and passes a parameter to the showHideTab() function

    $(".home__tabs ul").click(function(e) {
        if ($(e.target).is("a")) {
            // -- Handle Tab Nav
            $(".home__tabs > ul > li > a").removeClass("selected");
            $(e.target).addClass("selected");

            // -- Handles Tab Content
            var clicked_index = $("a", this).index(e.target);
            $(".home__tabs article").css("display", "none");
            $(".home__tabs article")
                .eq(clicked_index)
                .fadeIn();
        }

        $(this).blur();
        return false;
    });
    ScrollReveal().reveal(".landing__text h2", {
        delay: 200,
        duration: 500,
    });
});

// Menu
$(document).on("click", '[href="#menu"]', function(e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $("nav > ul").toggleClass("active");
});

// -- Overlay Toggle
$("#toggle").click(function() {
    $(this).toggleClass("active");
    $("#overlay").toggleClass("open");
});
